<template>
    <div>
        <NuxtPage />
    </div>
</template>

<script setup lang="ts">
    useHead({
        title: 'Order Online'
    })
    definePageMeta({
        layout: 'with-cart'
    })
</script>
